exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".opportunity-component{position:relative;font-size:16px;font-weight:700;width:100%;max-width:100%;background-color:#fff}.opportunity-component .title{position:absolute;font-size:20px;font-family:\\\\9ED1\\4F53;width:90%;padding:0 7% 0 15%;text-align:center;top:50%;margin-top:-20px;color:#fff}.opportunity-component .author{position:absolute;width:90%;padding:0 0 0 15%;text-align:left;top:50%;margin-top:-40px;color:#fff}.opportunity-component .close,.opportunity-component .price{position:absolute;width:100%;text-align:center;bottom:0;height:50px;line-height:50px;color:#fff;background-color:rgba(0,0,0,.3)}.opportunity-component .img-responsive{max-width:100%;min-height:200px;height:auto}.opportunity-component .center-block{display:block;margin-right:auto;margin-left:auto}.opportunity-component .image{border-style:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/styles/Opportunity.scss
// module id = 658
// module chunks = 0